class rfStep extends HTMLElement {
  connectedCallback() {
    this.type = this.dataset.type;
    this.step = parseInt(this.dataset.step);
    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach(i => i.addEventListener('change', (event) => this.handleChange(this, event)));
  }

  handleChange(stepEl, event) {
    document.dispatchEvent(new CustomEvent('rf-step-input-change', { 
      detail: {
        stepEl: stepEl,
        changedInput: event?.target || null
      } 
    }));
  }

  getData() {
    const data = {};
    if (this.type === 'skinType') {
      data.skinType = this.querySelector('input[type="radio"]:checked')?.value || '';
      data.skinSensitivity =
        this.querySelector('input[name="skinSensitivity"]')?.checked || false;
    } else if (this.type === 'skinConcerns') {
      data.skinConcerns = [...this.querySelectorAll('input[type="checkbox"]:checked')].map(i => i.value);
    } else if (this.type === 'eyeConcerns') {
      data.eyeConcerns = [...this.querySelectorAll('input[type="checkbox"]:checked')].map(i => i.value);
    } else if (this.type === 'results') {
      data.prds = [...this.querySelectorAll('input[type="checkbox"]:checked')].map(i => i.value);
    }
    return data;
  }
}
customElements.define('rf-question', rfStep);

class RFFooter extends HTMLElement {
  connectedCallback() {
    this.classList.add('rf-footer', 'color-scheme', 'color-scheme--scheme-1');
    this.backArrow = document.querySelector('[data-rf-landing="icon-arrow-left"]')?.innerHTML || '';
    this.innerHTML = `
      <progress-bar id="rf-landing-progress-bar" class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuenow="0" aria-valuemax="5"></progress-bar>
      <div class="container flex justify-between align-center h-full">
        <button id="rf-landing-backBtn" class="h-stack gap-2">${this.backArrow}Back</button>
        <div class="h-stack gap-3">
          <button class="button button--outline" id="rf-landing-skipBtn" style="--button-text-color: var(--button-background-primary)">Skip Results</button>
          <button class="button" id="rf-landing-nextBtn">Start Quiz</button>
        </div>
      </div>
    `;
    this.progressBar = this.querySelector('#rf-landing-progress-bar');
    this.backBtn = this.querySelector('#rf-landing-backBtn');
    this.nextBtn = this.querySelector('#rf-landing-nextBtn');
    this.skipBtn = this.querySelector('#rf-landing-skipBtn');

    this.backBtn.addEventListener('click', () =>
      document.dispatchEvent(new CustomEvent('rf-footer-back'))
    );
    this.nextBtn.addEventListener('click', () =>
      document.dispatchEvent(new CustomEvent('rf-footer-next'))
    );
    this.skipBtn.addEventListener('click', () =>
      document.dispatchEvent(new CustomEvent('rf-footer-skip'))
    );
  }

  update({ step, total }) {
    this.progressBar.setAttribute('aria-valuenow', step);
    
    // Landing step
    if (step === 0) {
      this.backBtn.hidden = true;
      this.skipBtn.hidden = true;
      this.nextBtn.disabled = false;
      this.nextBtn.classList.add('enabled');
      return;
    }

    this.backBtn.hidden = false;
    this.backBtn.disabled = step < 1;
    // Show Skip only on last step
    this.skipBtn.hidden = step !== total;
  }
}
customElements.define('rf-footer', RFFooter);

class RFLanding extends HTMLElement {
  constructor() {
    super();
    this.quizData = {};
    this.currentStep = 0;
  }

  connectedCallback() {
    const main = document.getElementById('main');
    const footerEl = document.createElement('rf-footer');
    main.appendChild(footerEl);

    this.footer = footerEl;
    this.steps = Array.from(this.querySelectorAll('rf-question'));
    this.landingSection = document.querySelector('.shopify-section--slideshow');
    this.heroButton = this.landingSection?.querySelector('button');

  
    if (this.heroButton && this.footer) {
      const heroText = this.heroButton.textContent.trim();
      this.heroText = heroText;
      this.footer.nextBtn.textContent = heroText;

      this.heroButton.addEventListener('click', () => this.startQuestion());
      this.footer.nextBtn.addEventListener('click', () => {
        if (this.currentStep === 0) this.startQuestion();
      });
    }
 
    document.addEventListener('rf-footer-next', () => this.handleNext());
    document.addEventListener('rf-footer-back', () => this.handleBack());
    document.addEventListener('rf-footer-skip', () => this.handleSkip());
    document.addEventListener('rf-step-input-change', e => this.refreshFooter(e.detail.stepEl, e.detail.changedInput));

    this.footer.update({ step: 0, total: this.steps.length });
  }

  startQuestion() {

    this.landingSection.hidden = true;
    this.hidden = false;

    this.currentStep = 1;
    this.showStep(this.currentStep);

    // Initialize footer for Step 1 state
    const firstStep = this.steps[0];
    this.refreshFooter(firstStep);
  }

  showStep(step) {
    this.steps.forEach((s, i) => (s.hidden = i + 1 !== step));
    this.currentStep = step;
    this.footer.update({ step, total: this.steps.length });

    // Update footer text dynamically per step
    if (step === 0) {
      // Landing
      this.footer.nextBtn.textContent = this.heroText;
      this.footer.nextBtn.disabled = false;
      this.footer.nextBtn.classList.add('enabled');
      return;
    }

    const activeStep = this.steps[step - 1];
    this.refreshFooter(activeStep);
  }

  handleNext() {
    if (this.currentStep === 0) {
      this.startQuestion();
      return;
    }

    const activeStep = this.steps[this.currentStep - 1];
    Object.assign(this.quizData, activeStep.getData());

    if (this.currentStep === this.steps.length) {
      this.redirectToResults(true); // Continue (include prds)
    } else {
      this.showStep(this.currentStep + 1);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  handleBack() {
    if (this.currentStep <= 1) {
      // Back to landing
      this.hidden = true;
      this.landingSection.hidden = false;
      this.currentStep = 0;

      this.footer.update({ step: 0, total: this.steps.length });
      // Reset footer back to hero button text
      this.footer.nextBtn.textContent = this.heroText;
      this.footer.nextBtn.disabled = false;
      this.footer.nextBtn.classList.add('enabled');
      return;
    }

    this.showStep(this.currentStep - 1);
    const activeStep = this.steps[this.currentStep - 1];
    this.refreshFooter(activeStep);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  sendResultPageMParticleEvent() {
    window.Shopify?.analytics?.publish("mp:rf-steps-navigation", {
      step: "Result Page",
    });
  }

  handleSkip() {
    const activeStep = this.steps[this.currentStep - 1];
    Object.assign(this.quizData, activeStep.getData());
    this.redirectToResults(false);
  }

  redirectToResults(includeProducts = true) {
    this.sendResultPageMParticleEvent()
    const final = {
      skinType: this.quizData.skinType || '',
      skinSensitivity: this.quizData.skinSensitivity || false,
      skinConcerns: [
        ...(this.quizData.skinConcerns || []),
        ...(this.quizData.eyeConcerns || [])
      ].join('|')
    };

    // Include or exclude products
    if (includeProducts && this.quizData.prds?.length) {
      final.prds = this.quizData.prds.join(',');
    }

    const query = new URLSearchParams(final).toString();
    setTimeout(() => {
      window.location.href = `/pages/ritualfinder-results?${query}`;
    }, 200);
  }

  refreshFooter(stepEl, changedInput = null) {
    const nextBtn = this.footer.nextBtn;
    const inputs = stepEl.inputs;

    if (stepEl.type === 'skinType') {
      const selected = [...inputs].filter(i => i.type === 'radio' && i.checked);
      nextBtn.disabled = selected.length === 0;
      nextBtn.classList.toggle('enabled', selected.length > 0);
      nextBtn.textContent = selected.length ? 'Continue' : 'Select Skin type';
      inputs.forEach(i => {
        i.classList.toggle('disabled', selected.length > 0 && !i.checked);
      });
    }

    if (stepEl.type === 'skinConcerns') {
      const selected = [...inputs].filter(i => i.checked);
      const count = selected.length;
      nextBtn.disabled = count < 1;
      nextBtn.classList.toggle('enabled', count >= 1);
      nextBtn.textContent = count >= 1 ? 'Continue' : 'Select Benefits';
      inputs.forEach(i => (i.disabled = count >= 3 && !i.checked));
    }

    if (stepEl.type === 'eyeConcerns') {
      if (changedInput && changedInput.type === 'checkbox') {
        if (changedInput.checked) {
          inputs.forEach(i => {
            if (i !== changedInput) i.checked = false;
          });
        }
      }

      const selected = [...inputs].filter(i => i.checked);
      inputs.forEach(i => {
        i.classList.toggle('disabled', selected.length > 0 && !i.checked);
      });
      nextBtn.textContent = 'Continue';
      nextBtn.disabled = false;
      nextBtn.classList.add('enabled');
    }

    if (stepEl.type === 'results') {
      nextBtn.textContent = 'Continue';
      nextBtn.disabled = false;
      nextBtn.classList.add('enabled');
    }
  }
}

customElements.define('rf-landing', RFLanding);


// --- Ritual Filter Component ---
class RitualFilter extends HTMLElement {
  constructor() {
    super();
  }

  set filters(data) {
    this._filters = data;
    this.render();
  }

  get selectedFilters() {
    const checkboxes = this.querySelectorAll('input[type="checkbox"]:checked');
    return Array.from(checkboxes).map(cb => cb.value);
  }

  render() {
    if (!this._filters || !this._filters.length) return;
    this.innerHTML = `
      <div class="rf-results__filters bleed scroll-area">
        ${this._filters
          .map(
            f => `
              <div class="rf-results__filter">
                <input class="rf-results__filter__input" id="rf-filter-${f.name}" type="checkbox" value="${f.name}" ${f.selected ? 'checked' : ''}>
                <label class="rf-results__filter__label" for="rf-filter-${f.name}">
                  ${f.name}
                </label>
              </div>
            `
          )
          .join('')}
      </div>
    `;
    this.addListeners();
  }
  addListeners() {
    this.querySelectorAll('[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', e => {
        const isChecked = e.target.checked;
        const value = e.target.value;

        this.dispatchEvent(new CustomEvent('filter-change', {
          detail: {
            checked: isChecked,
            value: value
          },
          bubbles: true,
          composed: true
        }));
      });
    });
  }
}

customElements.define('ritual-filter', RitualFilter);

// --- Ritual Product Card Component ---
class RitualProductCard extends HTMLElement {
  constructor() {
    super();
    this.iconPictoSun = document.querySelector('[data-rf-result="icon-picto-sun"]').innerHTML;
    this.iconMoon = document.querySelector('[data-rf-result="icon-moon"]').innerHTML;
    this.chevronDown = document.querySelector('[data-rf-result="icon-chevron-down"]').innerHTML;
  }
  set storageKey(value) {
    this._storageKey = value;
  }
  get storageKey() {
    return this._storageKey;
  }
  set product(data) {
    this._product = data;
    this.render();
  }

  checkSizeLabel(label){
    if (label && label.toLowerCase().includes('oz')) {
      const splitTitle = label.split('|');
      if (splitTitle.length > 1) {
        for (const sizeLabel of splitTitle) {
          if (sizeLabel.toLowerCase().includes('oz')) {
            return sizeLabel.trim();
          }
        }
      }else{
        return label;
      }
    }
    return label;
  }

  render() {
    const product = this._product;
    let sizeHtml = '';
    
    const sizes = product.sizes;

    // Hide size buttons if only one variant
    const hideSingleVariant = sizes.length <= 1 ? 'hidden' : '';

    // Find first available (in-stock) variant
    const firstAvailable = sizes.find(v => v.qty > 0);
    const allOutOfStock = sizes.every(v => v.qty <= 0);

    // Determine display price & default variant
    const displayPrice = firstAvailable ? firstAvailable.price : sizes[0]?.price || "0";

    const defaultVariantId = firstAvailable
      ? firstAvailable.id
      : sizes[0]?.id;

    // Generate variant buttons HTML
    sizeHtml = sizes
      .map((size, index) => {
        let sizeLabel = size.sizelabel ? size.sizelabel : this.checkSizeLabel(size.label);
        return `<button
          class="rf-results__product-card__${size.name}-btn ${size.name === 'color' ? `color-${size.label.toLowerCase()?.replace(' ', '-')}` : ''} 
            button button--outline ${index === 0 ? 'is-active' : ''} ${hideSingleVariant}"
          data-id="${size.id}"
          data-price="${size.price}"
          data-product-card="variant-btn"
          ${size.qty < 1 ? 'disabled' : ''}>
          <span class="${size.name === 'color' ? 'sr-only' : ''}">
            ${sizeLabel}
          </span>
        </button>
      `})
      .join('');
    

    const tags = product.label.map(tag => `<span class="badge badge--custom">${tag}</span>`).join("");
    const icons = product.usageTimeBoth ? this.iconPictoSun + this.iconMoon : product.usageTime === "AM" ? this.iconPictoSun : this.iconMoon;
    this.innerHTML = `
      <div class="rf-results__product-card">
        <div class="rf-results__product-card__img">
          <div class="rf-results__product-card__flag">
            <badge-list class="badge-list badge-list--column">
              ${tags}
            </badge-list>
            <div class="rf-results__product-card__usage-time" data-time-both="${product.usageTimeBoth}" data-time="${product.usageTime}">
              ${icons}
            </div>
          </div>
          <img class="constrained-image" data-product-card="img" src="${product.image}" width="340" height="268" alt="${product.name}">
        </div>
        <div class="rf-results__product-card__content">
          <div class="h-stack justify-start gap-1 wrap">
            ${sizeHtml}
          </div>
          <div class="rf-results__product-card__prose prose">
            <p class="bold" data-product-card="name">${product.name}</p>
            <p>${product.secondaryName || ''}</p>
            <p data-product-card="price">${displayPrice}</p>
          </div>
          <div class="rf-results__product-card__cta">
            <product-form class="js-product-form">
              <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
                  <input type="hidden" name="form_type" value="product" />
                  <input type="hidden" name="utf8" value="✓" />
                  <input type="hidden" name="quantity" value="1" />
                  <input type="hidden" name="id" value="${defaultVariantId}" />
                  <button type="submit" class="link" data-product-card="add-to-bag" ${allOutOfStock ? 'disabled' : ''}>
                    <button-content class="button__content">${allOutOfStock ? 'Out Of Stock' : 'Add to Bag'}</button-content>
                  </button>
              </form>
            </product-form>
            <button class="rf-results__product-card__accordion-cta" data-product-card="accordion-cta">${this.chevronDown}</button>
          </div>
          <div class="rf-results__product-card__accordion-content" data-product-card="accordion-content">
            <div class="rf-results__product-card__accordion-content__inner small-body-text">
              ${product.description ? product.description : ''} <a data-product-card="url" href="${product.url}" class="link">More info</a>
            </div>
          </div>
        </div>
      </div>
    `;

    this.addListeners();
  }

  addListeners() {

    // Accordion toggle
    this.querySelector('[data-product-card="accordion-cta"]').addEventListener('click', e => {
      e.currentTarget.classList.toggle('rf-results__product-card__accordion-cta--active');
      this.querySelector('[data-product-card="accordion-content"]').classList.toggle('rf-results__product-card__accordion-content--active');
    });

    // Variant select
    this.querySelectorAll('[data-product-card="variant-btn"]').forEach(btn => {
      btn.addEventListener('click', e => {
        this.querySelectorAll('[data-product-card="variant-btn"]').forEach(b => b.classList.remove('is-active'));
        e.currentTarget.classList.add('is-active');
        const price = e.currentTarget.dataset.price;
        const id = e.currentTarget.dataset.id;
        this.querySelector('[data-product-card="price"]').textContent = `${price}`;
        // this.querySelector('[data-product-card="add-to-bag"]').dataset.variant = id;
        this.querySelector('product-form [name="id"]').value = id;
      });
    });

    // Add to Bag
    /*
    <button class="link"
      data-product-card="add-to-bag"
      data-variant="${defaultVariantId}"
      ${allOutOfStock ? 'disabled' : ''}>
        <button-content class="button__content">Add to Bag</button-content>
    </button>
    this.querySelector('[data-product-card="add-to-bag"]').addEventListener('click', async e => {
      const button = e.currentTarget;
      const variantId = button.dataset.variant;
      button.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        button.removeAttribute('aria-busy', 'true');
        if (res.ok) {
          let cart = document.querySelector("a[href='/cart']");
          cart.click();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { 
              bubbles: true,
              detail: {
                  openGwpDrawer: true
              }
          }));
          localStorage.removeItem(this.storageKey);
        } else {
          const err = await res.json();
          console.error('Error adding to cart', err);
          localStorage.removeItem(this.storageKey);
          window.location.reload();
        }
      } catch (err) {
        console.error('Error adding to cart', err);
        localStorage.removeItem(this.storageKey);
        window.location.reload();
      }
    });*/
  }
}

customElements.define('ritual-product-card', RitualProductCard);

class RitualFinderResult extends HTMLElement {
  constructor() {
    super();
    this.userValue = this.querySelector('#rf_user_value')?.value;
    this.storageKey = "ritualfinder-cache";
    this.requestURL = this.querySelector('#rf_user_url')?.value;
    this.enableCache = this.querySelector('[data-rf-result="enable-cache"]')?.value === 'true';
    this.cacheDuration = Number(this.querySelector('[data-rf-result="cache-duration"]')?.value) || 0;

    this.products = {};
    this.filters = [];
    this.stepOrder = {};
    this.activeFilters = [];
    this.requestBody = [];
    this.allProductsByHandle = [];
    this.klaviyoEventsUrl = this.querySelector('#klaviyo_events_url')?.value;
    this.klaviyoSubscriptionUrl = this.querySelector('#klaviyo_subscription_url')?.value;
    this.klaviyoListId = this.querySelector('#klaviyo_list_id')?.value;
  }

  async connectedCallback() {
    await this.fetchProducts();
    this.recommendedRitual();   
    this.renderFilter();
    this.renderAllProducts();
    this.addAllToCart();
    this.emailDrawer();
    this.emailResult();
    this.cachedData = false;
  }
  async fetchProducts() {
    const query = window.location.search.substring(1);
    const payload = this.parseQuery(query);
    const payloadString = JSON.stringify(payload);

    const cached = localStorage.getItem(this.storageKey);
    if (this.enableCache && cached) {
      const { createdAt, requestBody, responseBody } = JSON.parse(cached);
      const age = Date.now() - createdAt;
      if (age < this.cacheDuration * 60 * 60 * 1000 && requestBody === payloadString) {
        this.products = responseBody.rfProducts || {};
        this.filters = responseBody.filters || [];
        this.stepOrder = responseBody.ritualFinderOrder || {};
        this.requestBody = JSON.parse(requestBody);
        this.cachedData = true;
        this.allProductsByHandle = await this.fetchAllProductsByHandle(this.products);
        return;
      } else {
        localStorage.removeItem(this.storageKey);
      }
    } else {
      localStorage.removeItem(this.storageKey);
    }
    
    const hmac = await this.generateHMAC(payload);
    const response = await fetch(this.requestURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Hmac-Sha256': hmac },
      body: payloadString
    });

    const result = await response.json();
    
    localStorage.setItem(this.storageKey, JSON.stringify({
      createdAt: Date.now(),
      requestBody: payloadString,
      responseBody: result
    }));

    this.products = result.rfProducts || {};
    this.filters = result.filters || [];
    this.stepOrder = result.ritualFinderOrder || {};
    this.requestBody = payload;
  }
  async fetchAllProductsByHandle(cacheProducts) {
    const handles = Object.values(cacheProducts).flatMap(arr =>
      arr.map(item => item.productInfo?.handle).filter(Boolean)
    );
    const products = await Promise.all(handles.map(this.fetchProductByHandle));
    const validProducts = products.filter(Boolean);
    return validProducts;
  }
  async fetchProductByHandle(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error(`Failed to fetch ${handle}`);
      const product = await res.json();
      return product;
    } catch (err) {
      console.error(`Error fetching ${handle}:`, err);
      return null;
    }
  }

  parseQuery(queryString) {
    const params = new URLSearchParams(queryString);
    const payload = {};
    for (const [key, value] of params.entries()) {
      payload[key] = value === 'true' ? true : value === 'false' ? false : decodeURIComponent(value);
    }
    return payload;
  }

  async generateHMAC(payload) {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(this.userValue);
    const msgData = encoder.encode(JSON.stringify(payload));
    const cryptoKey = await crypto.subtle.importKey("raw", keyData, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
    const signature = await crypto.subtle.sign("HMAC", cryptoKey, msgData);
    return btoa(String.fromCharCode(...new Uint8Array(signature)));
  }

  recommendedRitual() {
    const elem = this.querySelector('[data-rf-result="recommended-ritual"]');
    const skinConcerns = JSON.parse(this.querySelector('[data-rf-result="skin-concerns-value"]').value);
    const skinType = JSON.parse(this.querySelector('[data-rf-result="skin-type-value"]').value);
    const selectedSkinConcerns = this.requestBody.skinConcerns.split('|');
    const selectedSkinType = this.requestBody.skinType;
    const resultSkinType = skinType[selectedSkinType]?.label.toLowerCase();
    const resultSensitivity = this.requestBody.skinSensitivity ? 'that is also sensitive, ' : '';
    const resultSkinConcerns = selectedSkinConcerns.map(key => skinConcerns[key]?.label).filter(Boolean).join(", ").replace(/,([^,]*)$/, ' and$1').toLowerCase();
    const value = `Our recommended ritual for ${resultSkinType} skin ${resultSensitivity}with ${resultSkinConcerns} benefits.`;
    elem.textContent = value;
    elem.classList.remove('skeleton-loader');
  }

  renderFilter() {
    const filterEl = this.querySelector('[data-rf-result="filters"]');
    if (!filterEl) return;
    filterEl.filters = this.filters;

    this.addEventListener('filter-change', e => {
      const { checked, value } = e.detail;
      const steps = this.querySelector('[data-rf-result="steps"]');
      const productCards = this.querySelectorAll('ritual-product-card');
      const transition = 'rf-results__steps--transition-enabled';
      productCards.forEach(card => {
        if (card.getAttribute('data-filter') === value) {
          card.hidden = !checked;
        }
      });
      this.updateStepIndex();
      steps.classList.add(transition);
      setTimeout(() => {
        steps.classList.remove(transition);
      }, 200);
    });
  }

  /**
   * Render all products once with step ordering
   */
  renderAllProducts() {
    const stepContainer = this.querySelector('[data-rf-result="steps"]');
    if (!stepContainer) return;
    stepContainer.innerHTML = '';

    const defaultOrderList = this.stepOrder.default;

    // Find the index of 'Add-on1'
    const splitDefaultOrder = defaultOrderList.indexOf('Add-on1');

    // Use array slicing to split
    const mainKeys = defaultOrderList.slice(0, splitDefaultOrder);
    const addonKeys = defaultOrderList.slice(splitDefaultOrder);

    mainKeys.forEach(stepName => {
      const section = this.renderStep('', stepName, [stepName]);
      stepContainer.appendChild(section);
    });

    if (addonKeys.length) {
      const addonSection = this.renderStep('Add-ons', 'addon', addonKeys, true);
      stepContainer.appendChild(addonSection);
    }


    this.updateStepIndex();
  }

  renderStep(title, stepName, productKeys, isAddon = false) {
    const stepWrapper = document.createElement('div');
    stepName = stepName.replace('_', ' ');
    stepWrapper.classList.add('rf-results__step');
    stepWrapper.dataset.rfResult = 'step';
    stepWrapper.dataset.step = stepName;

    let isAddonHereRendered = false;
    productKeys.forEach(key => {
      const productList = this.products[key] || [];
      
      if (!productList.length) return;
      if(!isAddon || (isAddon && !isAddonHereRendered)) {
        const header = document.createElement('div');
        header.classList.add('prose', 'prose--compact');
        const description = `<p>${productList[0].description}</p>`;
        header.innerHTML = isAddon
        ? `<h2 class="h6">${title}</h2>${description}`
        : `<h2 class="h6">Step <span data-rf-result="step-index"></span>: ${stepName}</h2>${description}`;
        stepWrapper.appendChild(header);
        isAddonHereRendered = true;
      }

      productList.forEach(product => {
        const productInfo = product.productInfo;
        if (!productInfo || !Object.keys(productInfo).length) return;
        const card = document.createElement('ritual-product-card');
        card.storageKey = this.storageKey;
        card.classList.add('rf-results__product');
        card.dataset.filter = product.filterName;
        card.hidden = !product.display;
        card.product = this.constructProductCardData(product);
        stepWrapper.appendChild(card);
      });
    });

    return stepWrapper;
  }

  constructProductCardData(product) {
    const {label, usageTimeBoth, usageTime} = product;
    const formatPrice = window.themeVariables.settings.moneyFormat;
    if (!this.cachedData) {
      const info = product.productInfo;
      const variants = info.variant?.product?.variants?.edges || [];
      const sizes = variants.map(v => ({
        id: v.node.id.split('/').pop(),
        name: v.node.selectedOptions[0]?.name,
        label: v.node.selectedOptions[0]?.value,
        price: formatPrice.replace('{{amount}}', Math.floor(v.node.price)),
        qty: v.node.inventoryQuantity,
        sizelabel: v.node.metafields?.edges[0]?.node.key == "size_label" ?  v.node.metafields?.edges[0]?.node.value : ""
      }));

      return {sizes, usageTimeBoth, usageTime, label, ...product.productInfo}

    } else {
      const productByHandle = this.allProductsByHandle.find(h => h.handle === product.productInfo.handle);
      const {name, description, image, variant} = product.productInfo;
      const { id, options, variants, handle, price, url } = productByHandle;
      const matchedOption = options.find(opt => {
        const optName = opt.name?.toLowerCase();
        return optName.includes('size') || optName.includes('color');
      });
      const optionName = matchedOption?.name || options?.[0]?.name || 'Option';
      const sizeLabelMap = new Map();

      const extractNumericId = (fullId) => {
        if (!fullId) return null;
        const parts = fullId.split('/');
        return parts[parts.length - 1];
      };
      const productVariantsEdges = variant.product?.variants?.edges;
      if (productVariantsEdges) {
        productVariantsEdges.forEach(edge => {
          const variantNode = edge.node;
          const variantId = variantNode.id;
          const numericId = extractNumericId(variantId);

          if (!numericId) return;

          // Find the size_label metafield in this variant's metafields
          const sizeLabelMetafield = variantNode.metafields?.edges?.find(
            mfEdge => mfEdge.node.key === 'size_label'
          );

          if (sizeLabelMetafield) {
            sizeLabelMap.set(numericId, sizeLabelMetafield.node.value);
          } else {
            sizeLabelMap.set(numericId, "");
          }
        });
      }

      const sizes = variants.map(v => ({
        id: v.id,
        name: optionName,
        label: v.options?.[0] || v.title,
        price: formatPrice.replace('{{amount}}', (v.price / 100).toFixed()),
        qty: v.available ? 1 : 0,
        sizelabel: sizeLabelMap.get(String(v.id)) ? sizeLabelMap.get(String(v.id)) :  v.options?.[0] || v.title
      }));

      return { name, description, image, sizes, label, usageTimeBoth, usageTime, id, handle, price, url };
    }
  }

  updateStepIndex() {
    const steps = this.querySelectorAll('[data-rf-result="step"]');
    let stepIndex = 1;
    steps.forEach(step => {
      const cards = step.querySelectorAll('ritual-product-card');
      let allHidden = true;

      cards.forEach(card => {
        if (!card.hidden) {
          allHidden = false;
        }
      });

      // If all cards are hidden, hide the step
      if (allHidden) {
        step.hidden = true;
      } else {
        step.hidden = false;
        const stepIndexEle = step.querySelector('[data-rf-result="step-index"]');
        stepIndexEle && (stepIndexEle.textContent = stepIndex++);
      }
    });
  }
  emailDrawer() {
      const drawer = this.querySelector('#rf-result-email-drawer');
      drawer.addEventListener('dialog:after-hide', function(event) {
        const drawer = event.target;
        if (drawer.id === 'rf-result-email-drawer') {
          const form = drawer.querySelector('form');
          const msgEle = drawer.querySelector('[data-rf-result="email-msg"]');
          if (form.hasAttribute('hidden')) {
            form.reset();
            form.removeAttribute("hidden");
            msgEle.parentElement.setAttribute('hidden', '');
          }
        }
      });
  }
  emailResult() {
    const form = document.getElementById('rf-email-result');
    const submitButton = form.querySelector('button[type="submit"]');
    const msgEle = this.querySelector('[data-rf-result="email-msg"]');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      const username = formData.get('email');
      const isSubscribed = formData.get('news_and_offers');
      submitButton.setAttribute("aria-busy", "true");
      let promises = [this.createClientEvent(username)];
      if (isSubscribed) {
        promises.push(this.createClientSubscription(username));
      }
      const results = await Promise.all(promises);
      const events = results[0];
      const subscription = isSubscribed ? results[1] : null;
      submitButton.removeAttribute("aria-busy");
      setTimeout(() => {
        if(events.ok || subscription.ok) {
          const messge = events.ok && subscription && subscription.ok ? 'Thank you! Your results have been sent and your subscription is confirmed.' : 'Thank you! Your results have been sent.';
          msgEle.textContent = messge;
          msgEle.closest('[hidden]').removeAttribute('hidden');
          form.hidden = true;
        }
      }, 10);
    });
  }
  async createClientEvent(username) {
      const properties = this.buildProductPayload();
      const body = {
        "data": {
          "type": "event",
          "attributes": {
            "properties": properties,
            "metric": {
              "data": {
                "type": "metric",
                "attributes": {
                  "name": "Whatsnext mail"
                }
              }
            },
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": username
                }
              }
            }
          }
        }
      }
      const payload = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-10-15',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(body)
      };
      return await fetch(this.klaviyoEventsUrl, payload);
  }
  async createClientSubscription(username) {
    const body = {
      "data": {
        "type": "subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "properties": {
                  "Shopify Tags": ["newsletter","ritual finder"]
                },
                "subscriptions": {
                  "email": {
                    "marketing": {
                      "consent": "SUBSCRIBED"
                    }
                  }
                },
                "email": username
              }
            }
          }
        },
        "relationships": {
          "list": {
            "data": {
              "type": "list",
              "id": this.klaviyoListId
            }
          }
        }
      }
    }
    const payload = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(body)
    };
    return await fetch(this.klaviyoSubscriptionUrl, payload);
  }
  /**
   * Build productData payload from visible products
   */
  buildProductPayload() {
    const productData = {};

    const urlParams = new URLSearchParams(window.location.search);
    productData['sensitivity'] = urlParams.get('skinSensitivity') || false;
    productData['skinandEyeConcern'] = urlParams.get('skinConcerns') || '';
    productData['skinType'] = (urlParams.get('skinType') || '').toLowerCase();
    productData['prds'] = urlParams.get('prds') || '';
    productData['resultPage'] = window.location.href;

    const steps = this.querySelectorAll('[data-rf-result="step"]:not([hidden])');

    let amStepIndex = 1;
    let pmStepIndex = 1;
    steps.forEach(step => {
      const stepName = step.dataset.step || '';
      const products = step.querySelectorAll('ritual-product-card:not([hidden])');
      products.forEach(card => {
        const id = card.dataset.id || card.querySelector('.is-active[data-product-card="variant-btn"]')?.dataset.id;
        const name = card.querySelector('[data-product-card="name"]')?.textContent;
        const url = card.querySelector('[data-product-card="url"]').href;
        const image = card.querySelector('[data-product-card="img"]')?.src;
        const price = card.querySelector('[data-product-card="price"]')?.textContent.trim() || '';
        const time = card.querySelector('[data-time]')?.dataset.time; // card.dataset.time || card.getAttribute('data-time') || 'AM';
        const bothTime = card.querySelector('[data-time-both]')?.dataset.timeBoth;
        
        const timings = bothTime === 'true' ? ['AM', 'PM'] : [time];
        timings.forEach(value => {
          const keyValue = value == 'AM' ? 'AMRotine' : 'PMRoutine';
          const product = {
            stepNo: value == 'AM' ? amStepIndex++ : pmStepIndex++,
            id,
            name,
            url,
            image,
            tileImage: image,
            time: value,
            icon: value == "AM" ? '<i class="fa fa-sun"></i>' : '<i class="fa fa-moon fa-sm"></i>',
            stepName,
            price
          };
          if (!productData[keyValue]) productData[keyValue] = [];
          productData[keyValue].push(product);
        });
      });
    });

    return productData;
  }

  addAllToCart() {
    const button = this.querySelector('[data-rf-result="add-all-bag"]');
    if (!button) return;

    button.addEventListener('click', async () => {
      const items = [];
      
      this.querySelectorAll('ritual-product-card:not([hidden]) product-form').forEach(form => {
        const variantInput = form.querySelector('[name="id"]');
        const addToCartButton = form.querySelector('[data-product-card="add-to-bag"]');
        if (addToCartButton.hasAttribute('disabled') || !variantInput || !variantInput.value) return;
        const item = {
          id: Number(variantInput.value),
          quantity: 1
        };
        items.push(item);
      });
      if (!items.length) return;

      try {
        button.setAttribute('aria-busy', 'true');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        button.removeAttribute('aria-busy', 'true');
        if (res.ok) {
          let cart = document.querySelector("a[href='/cart']");
          cart.click();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { 
            bubbles: true,
            detail: {
                openGwpDrawer: true
            }
          }));
        } else {
          const err = await res.json();
          console.error('Error adding all items:', err.description || 'Error adding to cart.');
          localStorage.removeItem(this.storageKey);
          window.location.reload();
        }
      } catch (err) {
        console.error('Error adding all items:', err);
        localStorage.removeItem(this.storageKey);
        window.location.reload();
      }
    });
  }
}

customElements.define('ritualfinder-result', RitualFinderResult);
